import * as React from 'react'
import classNames from 'classnames'
import './FlexContainer.scss'

export interface IProps {
  children: any;
  justifyContent?: 'between';
  alignItems?: 'center';
  className?: string;
}

const FlexContainer = ({ children, justifyContent, alignItems, className }: IProps) => {
  const classes = classNames(
    className,
    'flex-container',
    justifyContent ? `justify-${justifyContent}` : null,
    alignItems ? `align-${alignItems}` : null
  );

  return (
    <div className={classes}>{children}</div>
  );
}

export default FlexContainer;



// WEBPACK FOOTER //
// ./src/components/Layout/FlexContainer.tsx